module.exports = __webpack_public_path__ + "img/loading.723bf622.gif";